import React from 'react'
import Footer from '../component/Footer/Footer'
import PlainHero from '../component/PlainHero/PlainHero'
import NewsListNew from '../component/NewsListNew/NewsListNew'
import { Helmet } from 'react-helmet'

function News() {
  return (
    <>
     <Helmet>
          <title> 
          Interior Surface Ideas & Insights | Halton Surface Blog
          </title>
          <meta 
          name='description' 
          content="Explore the Halton Surface Systems blog for expert tips, trends & insights on commercial upholstery fabric, 3M Di-NOC finishes & decorative wall panels across Burlington & Ontario." 
          />
          <link rel="canonical" href="https://www.haltonsurfacesystems.com/blog" />

        </Helmet>
       <PlainHero
            Heading="Blogs"
            fontDark={true}
        />
    
       <NewsListNew/>

    <Footer/>
  
    </>
  )
}

export default News